import { VuiInProgress } from "../../../lib";

export const InProgress = () => {
  return <VuiInProgress label="Enciphering" />;
};
